import { Routes } from '@angular/router';
import { DefaultLayout } from './layout/default-layout/default-layout';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { UserLayoutComponent } from './layout/user-layout/user-layout.component';
import { thankUGuard } from './core/guards/thank-u.guard';

// Nota: el path '' siempre hace match; para evitar que capture '/auth',
// declaramos primero la ruta de 'auth' (más específica) y luego la base.
export const routes: Routes = [
  {
  path: 'auth/verify-totp',
  loadComponent: () =>
    import('./pages/auth/verify-totp/verify-totp.component').then(m => m.VerifyTotpComponent),
  },
  // Standalone landing without layout
  {
    path: 'manifiesta-un-abrazo-2026',
    loadComponent: () =>
      import('./pages/landings/arcadia-navidad/arcadia-navidad.component').then(
        (m) => m.ArcadiaNavidadComponent,
      ),
    data: { title: 'Arcadia Navidad 2026' },
  },
  {
    path: 'manifiesta-un-abrazo-2026/plan',
    loadComponent: () =>
      import('./pages/landings/arcadia-navidad-form/arcadia-navidad-form.component').then(
        (m) => m.ArcadiaNavidadFormComponent,
      ),
    data: { title: 'Activa tu plan de reencuentro' },
  },
  {
    path: 'manifiesta-un-abrazo-2026/confirm',
    loadComponent: () =>
      import('./pages/landings/arcadia-navidad-confirm/arcadia-navidad-confirm.component').then(
        (m) => m.ArcadiaNavidadConfirmComponent,
      ),
    data: { title: 'Confirmación de plan' },
  },
  {
    path: 'thank-u',
    loadComponent: () =>
      import('./pages/landings/thank-u/thank-u.component').then((m) => m.ThankUComponent),
    canActivate: [thankUGuard],
    data: { title: '¡Solicitud Recibida!' },
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    loadChildren: () => import('./pages/auth.route').then((mod) => mod.AUTH_ROUTES),
  },
  {
    path: 'user',
    component: UserLayoutComponent,
    loadChildren: () => import('./pages/user.route').then((mod) => mod.USER_ROUTES),
  },
  {
    path: '',
    component: DefaultLayout,
    loadChildren: () => import('./pages/index.route').then((mod) => mod.PRINCIPAL_ROUTES),
  },
];
